import { DetalleDte } from "src/app/models/Dte/DetalleDte";
import { DteEmitido } from "src/app/models/Dte/DteEmitido";
import { ReferenciaDteEmitido } from "src/app/models/Dte/ReferenciaDteEmitido";

const MAXIMO_GUIAS_INDIVIDUALES = 40;

export function mapearGuiasAReferencias(guias: DteEmitido[]): ReferenciaDteEmitido[] {
	const guiasValidas = (guias || []).filter(Boolean);
	if (guiasValidas.length === 0) return [];
	if (guiasValidas.length <= MAXIMO_GUIAS_INDIVIDUALES) {
		return guiasValidas.map(mapearGuiaAReferencia);
	}
	return [agruparReferenciasDeGuias(guiasValidas)];
}

export function mapearReferenciasDocumentosDeGuias(guias: DteEmitido[]): ReferenciaDteEmitido[] {
	return (guias || []).filter(Boolean).reduce((referencias, guia) => {
		const adicionales = (guia.listaReferenciasDteEmitido || []).map((original) => {
			const referencia = Object.assign(new ReferenciaDteEmitido(), original);
			referencia.razonReferencia = `${original.razonReferencia || ""} referenciada por Guía de Despacho ${guia.folio}`;
			return referencia;
		});
		return referencias.concat(adicionales);
	}, [] as ReferenciaDteEmitido[]);
}

export function mapearGuiaAReferencia(guia: DteEmitido): ReferenciaDteEmitido {
	const referencia = new ReferenciaDteEmitido();
	referencia.codigoTipoDteReferencia = guia.codigoTipoDte.toString();
	referencia.folioReferencia = guia.folio.toString();
	referencia.fechaDteReferenciado = guia.fecha;
	referencia.razonReferencia = "Guia de despacho " + referencia.folioReferencia;
	return referencia;
}

export function agruparReferenciasDeGuias(guias: DteEmitido[]): ReferenciaDteEmitido {
	const referencia = new ReferenciaDteEmitido();
	referencia.codigoTipoDteReferencia = guias[0].codigoTipoDte.toString();
	referencia.fechaDteReferenciado = new Date();
	referencia.razonReferencia = "FACTURACIÓN DE GUÍAS GLOBAL";
	referencia.folioReferencia = guias.map((guia) => guia.folio.toString()).join(", ");
	return referencia;
}

export function mapearGuiasADetalles(guias: DteEmitido[]): DetalleDte[] {
	const guiasValidas = (guias || []).filter(Boolean);
	if (guiasValidas.length <= MAXIMO_GUIAS_INDIVIDUALES) {
		return guiasValidas.reduce((detalles, guia) => {
			const detallesGuia = (guia.detalleDte || []).map(ajustarDetalleDeGuia);
			return detalles.concat(detallesGuia);
		}, [] as DetalleDte[]);
	}

	return guiasValidas.reduce((detalles, guia) => {
		const detallesGuia = guia.detalleDte || [];
		const exentos = detallesGuia.filter((detalle) => detalle.esExento);
		const afectos = detallesGuia.filter((detalle) => !detalle.esExento);

		if (exentos.length > 0) detalles.push(agruparDetallesDeGuia(exentos, guia));
		if (afectos.length > 0) detalles.push(agruparDetallesDeGuia(afectos, guia));
		return detalles;
	}, [] as DetalleDte[]);
}

function ajustarDetalleDeGuia(detalleOriginal: DetalleDte): DetalleDte {
	const detalle = Object.assign(new DetalleDte(), detalleOriginal);
	if (detalle.precioUnidadMedida * detalle.cantidad < detalle.total && detalle.cantidad === 1) {
		detalle.precioUnitario = detalle.total;
	}
	return detalle;
}

function agruparDetallesDeGuia(detalles: DetalleDte[], guia: DteEmitido): DetalleDte {
	const primerDetalle = detalles[0];
	const detalleAgrupado = new DetalleDte();
	detalleAgrupado.dteId = primerDetalle.dteId;
	detalleAgrupado.cantidad = 1;
	detalleAgrupado.esExento = !!primerDetalle.esExento;
	detalleAgrupado.descripcion = primerDetalle.esExento ? "Elementos Exentos Guía Folio: " + guia.folio : "Elementos Afectos Guía Folio: " + guia.folio;
	detalleAgrupado.precioUnitario = detalles.reduce((total, detalle) => total + Number(detalle.precioUnitario || 0), 0);
	detalleAgrupado.total = detalles.reduce((total, detalle) => total + Number(detalle.total || 0), 0);
	return detalleAgrupado;
}

